type Props = {
  colors: string[];
  id: string;
};

export default function ColorStripesPattern({ colors, id }: Props) {
  const stripeWidth = 8;
  return (
    <pattern
      id={id}
      width={stripeWidth * colors.length}
      height={stripeWidth * colors.length}
      viewBox={`0 0 ${stripeWidth * colors.length}px ${stripeWidth * colors.length}px`}
      patternUnits="userSpaceOnUse"
    >
      <g transform="scale(.707106781) rotate(45)" transform-origin="center, center">
        {colors
          .concat(colors)
          .map((color, i) => [
            <rect
              x={i * stripeWidth}
              y={-stripeWidth * colors.length * 2}
              height={stripeWidth * colors.length * 6}
              width={stripeWidth * 2}
              fill={color}
            />,
            <rect
              x={i * stripeWidth}
              y={-stripeWidth * colors.length * 2}
              height={stripeWidth * colors.length * 6}
              width={stripeWidth * 2}
              fill={color}
            />,
          ])}
      </g>
    </pattern>
  );
}
